<script setup>
import TvStationsLogoFooter from '@/components/elements/TvStationsLogoFooter.vue'
import { computed, onMounted } from 'vue';
import { useFooterStore } from "@/stores/footer";
import { useSectionsStore } from '@/stores/section'
import { storeToRefs } from 'pinia';

const footerStore = useFooterStore()
const sectionsStore = useSectionsStore()
const { footerUrls } = storeToRefs(footerStore)
const { pageSettingId } = storeToRefs(sectionsStore)
const { fetchFooterUrls } = footerStore
const footerUrlsLength = computed(() => footerUrls.value.length)
const currentYear = new Date().getFullYear()
const firstTwoFooterColumns = computed(() => {
  return footerUrls.value.slice(0, 2);
});
const hideSlots = computed(() => pageSettingId.value === 88934801 || pageSettingId.value === 85815072)

const openConsent = () => {
  window.scrollTo(0, 0)
  window.openConsentWindow()
}

const closeStickyAd = () => {
  let stickyWrapper = document.querySelector(".stickyad__wrapper.loaded");
  stickyWrapper.classList.remove('loaded');
}

onMounted(() => {
  fetchFooterUrls()
})

</script>
<template>
  <footer class="footer">
    <div class="container">
      <div class="footer__container">
        <div class="columns is-multiline">
          <div class="column is-3-desktop is-12-tablet is-12-mobile">
            <div class="footer__social">
              <div class="footer__social-logo">
                <img src="../../assets/images/logos/tvp-info-black-logo-2024.svg" alt="TVP Info logo" />
              </div>
              <div class="footer__social-media">
                <a href="https://www.facebook.com/tvp.info" class="facebook" target="_blank">
                  <i class="social-icon icon-facebook"></i>
                </a>
                <a href="http://twitter.com/tvp_info" class="twitter" target="_blank">
                  <i class="social-icon icon-twitter-new black"></i>
                </a>
                <a href="https://www.youtube.com/user/YTtvpinfo" class="youtube" target="_blank">
                  <i class="social-icon icon-youtube black"></i>
                </a>
                <a href="https://www.instagram.com/tvp.info/" class="instagram" target="_blank">
                  <i class="social-icon icon-instagram black"></i>
                </a>
                <a href="https://www.tiktok.com/@tvp.info" class="tiktok" target="_blank">
                  <i class="social-icon icon-tiktok black"></i>
                </a>
                <a href="https://bsky.app/profile/tvp.info" class="bluesky" target="_blank">
                  <i class="social-icon icon-bluesky black"></i>
                </a>
              </div>
            </div>
          </div>

          <template v-if="footerUrlsLength">
            <div
              v-for="footerLinks in firstTwoFooterColumns" 
              :key="footerLinks._id" 
              class="column is-3-desktop is-6-tablet is-12-mobile"
              >
              <div 
                class="footer__wrapper"
                v-if="footerLinks && footerLinks.items"
              >
                <ul>
                  <li v-for="item in footerLinks.items" :key="item._id" class="footer__box">
                    <a :href="item.url" class="footer__detail">{{ item.title }}</a>
                  </li>
                </ul>
              </div>
            </div>
        </template>

          <div class="column is-3-desktop is-12-tablet is-12-mobile">
            <!-- Banner do LP -->
            <a class="footer__app-banner" href="/aplikacja">
              <img src="@/assets/images/banner/banner-footer-2024.png" alt="App" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="footer__wrap">
      <div class="footer__content">
        <ul class="footer__menu">
          <li class="footer__news">
            <a href="http://bialystok.tvp.pl/" class="footer__item">Białystok</a>
          </li>
          <li class="footer__news">
            <a href="http://bydgoszcz.tvp.pl/" class="footer__item">Bydgoszcz</a>
          </li>
          <li class="footer__news">
            <a href="http://gdansk.tvp.pl/" class="footer__item">Gdańsk</a>
          </li>
          <li class="footer__news">
            <a href=" http://gorzow.tvp.pl/ " class="footer__item">Gorzów WLKP.</a>
          </li>
          <li class="footer__news">
            <a href="http://katowice.tvp.pl/" class="footer__item">Katowice</a>
          </li>
          <li class="footer__news">
            <a href=" http://kielce.tvp.pl/" class="footer__item">Kielce</a>
          </li>
          <li class="footer__news">
            <a href=" http://krakow.tvp.pl/" class="footer__item">Kraków</a>
          </li>
          <li class="footer__news">
            <a href="http://lublin.tvp.pl/" class="footer__item">Lublin</a>
          </li>
          <li class="footer__news footer__show">
            <a href="http://lodz.tvp.pl/" class="footer__item">Łódź</a>
          </li>
          <li class="footer__news footer__show">
            <a href="http://olsztyn.tvp.pl/" class="footer__item">Olsztyn</a>
          </li>
          <li class="footer__news footer__show">
            <a href="http://opole.tvp.pl/" class="footer__item">Opole</a>
          </li>
        </ul>
        <ul class="footer__menu footer__last">
          <li class="footer__news footer__hide">
            <a href="http://lodz.tvp.pl/" class="footer__item">Łódź</a>
          </li>
          <li class="footer__news footer__hide">
            <a href="http://olsztyn.tvp.pl/" class="footer__item">Olsztyn</a>
          </li>
          <li class="footer__news footer__hide">
            <a href="http://opole.tvp.pl/" class="footer__item">Opole</a>
          </li>
          <li class="footer__news">
            <a href="http://poznan.tvp.pl/" class="footer__item">Poznań</a>
          </li>
          <li class="footer__news">
            <a href="http://rzeszow.tvp.pl/" class="footer__item">Rzeszów</a>
          </li>
          <li class="footer__news">
            <a href="http://szczecin.tvp.pl/" class="footer__item">Szczecin</a>
          </li>
          <li class="footer__news">
            <a href="http://warszawa.tvp.pl/" class="footer__item">Warszawa</a>
          </li>
          <li class="footer__news">
            <a href="http://wroclaw.tvp.pl/" class="footer__item">Wrocław</a>
          </li>
        </ul>
      </div>
    </div>
    <tv-stations-logo-footer />
    <div class="footer__copyright">
      <p class="footer__use">© {{ currentYear }} Telewizja Polska S. A. w likwidacji</p>
    </div>
    <div class="stickyad__wrapper ad_slot" v-if="!hideSlots">
        <div @click="closeStickyAd" class="stickyad__close"><div class="stickyad__close-wrapper">Zamknij<i class="stickyad__close-icon"></i></div></div>
        <div id="stickyad" class="stickyad ad_wrapper"></div>
    </div>

    <div class="interstitial__wrapper ad_slot" v-if="!hideSlots"> 
      <div class="interstitial__header">
        <div class="interstitial__btn">przejdź do serwisu <i class="interstitial__header-icon"></i></div>

        <div class="interstitial__counter">
          <div class="interstitial__counter-info"><span class="interstitial__counter-text">REKLAMA:</span><span class="interstitial__counter-text">Przekierowanie za:</span></div>
          <span class="interstitial__counter-number"></span>
        </div>
              
        <span class="interstitial__progressbar"></span>
      </div>

      <div class="interstitial__container">
        <div id="interstitial" class="interstitial"></div>
      </div>
    </div>
  </footer>
</template>

<style lang="scss">
@import '@/assets/scss/components/layout/footer-layout.scss';
</style>
